var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1775 4.08325C3.67036 4.08325 3.25 4.4988 3.25 5.02325V15.8099C3.25 16.3344 3.67036 16.7499 4.1775 16.7499H15.8225C16.3296 16.7499 16.75 16.3344 16.75 15.8099V10.8891C16.75 10.4749 17.0858 10.1391 17.5 10.1391C17.9142 10.1391 18.25 10.4749 18.25 10.8891V15.8099C18.25 17.1521 17.1687 18.2499 15.8225 18.2499H4.1775C2.83131 18.2499 1.75 17.1521 1.75 15.8099V5.02325C1.75 3.68103 2.83131 2.58325 4.1775 2.58325H10C10.4142 2.58325 10.75 2.91904 10.75 3.33325C10.75 3.74747 10.4142 4.08325 10 4.08325H4.1775Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9814 3.29125C14.9252 2.34752 16.455 2.34752 17.3988 3.29125L17.5421 3.43459C18.4858 4.37831 18.4858 5.90818 17.5421 6.85191L10.5504 13.8436L10.5484 13.8456C10.3466 14.0458 10.0942 14.1901 9.81455 14.26L6.70539 15.0375C6.44979 15.1014 6.1794 15.0265 5.99311 14.8402C5.80681 14.6539 5.73193 14.3836 5.79584 14.128L6.5603 11.0709C6.56619 11.0399 6.57401 11.0094 6.58365 10.9797C6.65652 10.7169 6.79618 10.4765 6.98977 10.2829L13.9814 3.29125ZM7.88122 11.9718L7.55432 13.279L8.86078 12.9523C8.74385 12.4693 8.36405 12.0892 7.88122 11.9718ZM10.1552 12.1175C9.87074 11.4775 9.35608 10.9626 8.71628 10.6777L15.0421 4.35191C15.4 3.99397 15.9802 3.99397 16.3381 4.35191L16.4814 4.49524C16.8394 4.85318 16.8394 5.43331 16.4814 5.79125L10.1552 12.1175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAssessment);
export default __webpack_public_path__ + "static/media/icons-assessment.6eb62b346dcd87333dac8cabb62aa7c0.svg";
export { ForwardRef as ReactComponent };